import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CodigoCanales from "./CodigoCanales";
import Favoritos from "./Favoritos";
import Fecha from "./Fecha";
import Stats from "./Stats";
import BtnBucar from "./BtnBuscar";
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { useParams } from "react-router-dom";

export default function AppBarTop() {

  return (
    <>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        <Toolbar sx={{ flexWrap: "wrap" }}>
          <Typography variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
          <Button 
                     size="small" 
                     startIcon={<ArrowBackIcon />}
                     onClick={() => window.history.back()}>
                    San Pablo
                    </Button>
          </Typography>
          <Favoritos/>
          <Stats/>
          <CodigoCanales />
          <Fecha />
          <BtnBucar />
          {/* <Button href="#" variant="outlined" sx={{ my: 1, mx: 1.5 }}>
            Login
          </Button> */}
        </Toolbar>
      </AppBar>
    </>
  );
}